import { ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { GaleriaService } from 'src/app/core/galeria/galeria.service';
import { GalleryImage } from '../../models/galeryImage';

@Component({
  selector: 'app-gallery-modal',
  templateUrl: './gallery-modal.component.html',
  styleUrls: ['./gallery-modal.component.scss']
})
export class GalleryModalComponent implements OnInit, OnDestroy {

  public image: GalleryImage;
  @Input() gallery: GalleryImage[] = [];
  titulo: string;
  @Input() descripcion: string;
  @Input() position: number;
  spinner = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { titulo: string, descripcion: string; gallery: GalleryImage[]; position: number },
    private ref: ChangeDetectorRef,
    private readonly galleryService: GaleriaService
  ) {
    if (data) {
      this.titulo = data.titulo;
      this.descripcion = data.descripcion;
      this.gallery = data.gallery;
      this.position = data.position;
    }
  }

  ngOnInit(): void {
    this.getImageSelected();

  }

  getImageSelected(): void {
    this.image = this.gallery.find(d => d.position == this.position);

  }

  changeImg(move: number): void {
    const position = this.image.position + move;
    let nuevaImg = this.gallery[position];
    if (nuevaImg) {
      this.image = nuevaImg;
    }
  }

  ngOnDestroy(): void {
    this.gallery = [];
    this.galleryService.createGallery(this.gallery);
    this.image = null;
  }

}
